import styled from 'styled-components';

import { Text } from 'features/common/components/Text';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	width: 100%;
	min-height: 240px;
	padding: 32px 24px;
	box-sizing: border-box;
	text-align: center;
`;

export const Title = styled(Text)<{ isPunchup?: boolean }>`
	font-size: 20px;
	font-weight: 600;
	line-height: 150%;
	text-transform: none;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
`;

export const Description = styled(Text)<{ isPunchup?: boolean }>`
	font-size: 14px;
	font-weight: 400;
	line-height: 150%;
	max-width: 420px;
	text-transform: none;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey6 : theme.colors.lightGrey2)};
`;
